import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const StateMasterPopup = (props) => {
    return (
        <ModalBasic
            id="stateMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">State details</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Select country</label>
                        <MultiSelectDropdown
                            drpIdentity="Account head"
                            options={props.stateObject.countryList}
                            //value={props.stateObject.idCountry}
                            value={props.stateObject.idCountry ? props.stateObject.countryList.find(x => x.value === props.stateObject.idCountry) : 0}
                            onChange={(selected) =>
                                props.handleChangeFroDropdown(selected, "idCountry")
                            }
                            className={props.validState?.error?.idCountry !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>State name</label>
                        <TextInput type='text'
                            id='stateName' name='stateName'
                            value={props.stateObject.stateName}
                            handleChange={(event) => props.handleChange(event, 'stateName')}
                            className={props.validState?.error?.stateName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.stateObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}